export default function popupObserver() {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Element node
                    // Check if it's the iframe or contains the iframe
                    const iframe = node.matches?.('iframe[data-test-id="interactive-frame"]')
                        ? node
                        : node.querySelector?.('iframe[data-test-id="interactive-frame"]');

                    if (iframe && iframe.hasAttribute('role')) {
                        iframe.removeAttribute('role');

                        const container = iframe.closest('#hs-overlay-cta-242686004447');
                        if (container && !container.hasAttribute('role')) {
                            container.setAttribute('role', 'dialog');
                            container.setAttribute('aria-modal', 'true');
                            container.setAttribute('aria-label', 'News popup');
                        }
                    }
                }
            });
        });
    });

// Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

// Stop observing after 10 seconds (optional cleanup)
    setTimeout(() => observer.disconnect(), 10000);
}
